import {
  toast_outlet_styles_default
} from "./chunk.EGY6XIY5.js";
import {
  o
} from "./chunk.OBPYZVEK.js";
import {
  e,
  i,
  n
} from "./chunk.D5EJUUKV.js";
import {
  $,
  s
} from "./chunk.4JTBA2KG.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/toast-outlet/toast-outlet.ts
var FadvToastOutlet = class extends s {
  constructor() {
    super(...arguments);
    this.position = "top-center";
    this.backdrop = false;
  }
  handleContentSlotChange() {
    const slot = this.toastElement.querySelector("slot");
    this.toastElement.classList.toggle("toast-outlet--hidden", !slot.assignedElements().length);
  }
  renderContent() {
    if (!this.backdrop)
      return $`<slot></slot>`;
    return $`<div class="toast-outlet__content"><slot @slotchange=${this.handleContentSlotChange}></slot></div>`;
  }
  render() {
    return $`<div part="base" class=${o({
      "toast-outlet": true,
      "toast-outlet--has-backdrop": this.backdrop,
      "toast-outlet--top-left": this.position === "top-left",
      "toast-outlet--top-right": this.position === "top-right",
      "toast-outlet--top-center": this.position === "top-center",
      "toast-outlet--bottom-left": this.position === "bottom-left",
      "toast-outlet--bottom-right": this.position === "bottom-right",
      "toast-outlet--bottom-center": this.position === "bottom-center"
    })} >${this.renderContent()}</div>`;
  }
};
FadvToastOutlet.styles = toast_outlet_styles_default;
__decorateClass([
  e({ reflect: true })
], FadvToastOutlet.prototype, "position", 2);
__decorateClass([
  e({ reflect: true })
], FadvToastOutlet.prototype, "backdrop", 2);
__decorateClass([
  i(".toast-outlet")
], FadvToastOutlet.prototype, "toastElement", 2);
FadvToastOutlet = __decorateClass([
  n("fadv-toast-outlet")
], FadvToastOutlet);

export {
  FadvToastOutlet
};
